import { Item } from "@/api"
import ItemMasterDataTable from "./ItemMasterDataTable"
import SeparablePanel from "@/components/SeparablePanel"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { useMemo, useState } from "react"
import { ItemStats } from "./ItemTreeTable"
import { Message } from "primereact/message"
import InventoryChart from "./charts/InventoryChart"
import ItemProductionDataTable from "./ItemProductionDataTable"
import { Panel } from "primereact/panel"
import { Checkbox } from "primereact/checkbox"
import SummaryChart from "./charts/summaryChart"
import ItemProductionSummary from "./ItemProductionSummary"

interface ICategoryDetailProps {
  items: Item[],
  dates: string[]
  itemStats: Record<Item["品目ID"], ItemStats>
  inventories: Record<Item["品目ID"], number[]>
  shipments: Record<Item["品目ID"], number[]>
  productions: Record<Item["品目ID"], number[]>;
}

const CategoryDetail = ({ items,itemStats,inventories,shipments,productions,dates }: ICategoryDetailProps) => {
  const [filterSeectedItems, setFilterSeectedItems] = useState<Item[]>([])
  const [compare, setCompare] = useState(false)
  const [simple, setSimple] = useState(false)
  const filteredSelectedItems = useMemo(() => {
    return filterSeectedItems.length > 0 ? filterSeectedItems : items
  }, [filterSeectedItems, items])
  const filteredSelectedItemSummary = useMemo(() => {
    if (filteredSelectedItems.length === 0) return []
    const summary = {
      '出荷数合計': filteredSelectedItems.reduce((sum, item) => sum + itemStats[item.品目ID].総出荷, 0),
      '生産数合計': filteredSelectedItems.reduce((sum, item) => sum + itemStats[item.品目ID].総生産, 0),
      // '生産回数（のべ）': filteredSelectedItems.map(item => item.生産日).flat().length,
      // '生産日': [...new Set(filteredSelectedItems.map(item => item.生産日).flat())].length,
      // '工程時間合計': filteredSelectedItems.reduce((sum, item) => sum + item.工程時間, 0),
    }
    return Object.entries(summary).map(([label, value]) => ({ label, value }))
  }, [filteredSelectedItems])


  return (
    <div className="flex flex-column gap-2">
      <h3>分類の詳細</h3>
      <div className="py-2 flex flex-row gap-2">
      <label className="flex flex-row gap-2 line-height-2">
        <Checkbox
        value={true}
        checked={compare}
        onChange={(e) => {
          console.log("compare", e.checked)
          setCompare(e.checked ?? false)
        }}
        />
        <span>Excel上の計画と比較する</span>
      </label>
      <label className="flex flex-row gap-2 line-height-2">
        <Checkbox
        value={true}
        checked={simple}
        onChange={(e) => {
          setSimple(e.checked ? true : false)
        }}
        />
        <span>在庫切れ以外も表示</span>
      </label>
      </div>
    <SeparablePanel toggleable header="在庫推移予測サマリ">
        <SummaryChart
          items={filteredSelectedItems}
          日付={dates}
          inventories={inventories}
          shipments={shipments}
          productions={productions}
          compare={compare}
          simple={!simple}
        />
    </SeparablePanel>
    <SeparablePanel toggleable header="品目別サマリ">
      <ItemProductionSummary
      items={filteredSelectedItems}
      日付={dates}
      inventories={inventories}
      shipments={shipments}
      productions={productions}
      compare={compare}
      />
    </SeparablePanel>
    </div>
  )
}

export default CategoryDetail
